import { RadioButtonGroup, RadioButton } from '@carbon/react';
import { format0 } from 'utils/number';
import type { FilterTemplateProps } from '../../types';
import { useModalFacets, useCategoryFields } from '../template-hooks';
import style from '../filter-modal.module.scss';

const ALL_VALUE = '__all__';

export const RadioTemplate = ({
  category,
  formValues,
  onFormChange,
}: FilterTemplateProps) => {
  const facets = useModalFacets();
  const fields = useCategoryFields(category, 'radio');

  return (
    <div className={style.fieldStack}>
      {fields.map((field) => {
        const buckets = facets?.[field.facetKey]?.buckets ?? [];
        const selected = (formValues[field.param] as string | undefined) ?? '';

        return (
          <RadioButtonGroup
            key={field.id}
            legendText={field.label}
            name={`radio-${field.id}`}
            orientation="vertical"
            valueSelected={selected || ALL_VALUE}
            onChange={(value: string | number | undefined) =>
              onFormChange(
                field.param,
                value === ALL_VALUE ? undefined : String(value)
              )
            }
          >
            <RadioButton
              id={`radio-${field.id}-all`}
              labelText={field.allLabel ?? 'All'}
              value={ALL_VALUE}
            />
            {buckets.map((bucket) => (
              <RadioButton
                key={bucket.id}
                id={`radio-${field.id}-${bucket.id}`}
                labelText={`${field.label} = ${bucket.name} (${format0(
                  bucket.count
                )})`}
                value={bucket.id}
              />
            ))}
          </RadioButtonGroup>
        );
      })}
    </div>
  );
};
